import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import usePagination from "@mui/material/usePagination/usePagination";

export default function CustomPafinationComp({
  currentPage,
  totalPages,
  onPageChange,
}) {



  const pagination = usePagination({
    count: totalPages,
    page: currentPage,
    onChange: (event, page) => {
      onPageChange(page);
    },
  });




  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Typography
        onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
        sx={{
          mr: 2,
          color: currentPage === 1 ? "#ccc" : "#000",
          cursor: currentPage === 1 ? "not-allowed" : "pointer",
          fontFamily: "Inter",
          fontSize: "14px",
        }}
      >
        Previous
      </Typography>

      <Box display="flex" alignItems="center" gap={2}>
        {pagination.items.map(({ page, type, selected, ...item }, index) => {
          if (type === "start-ellipsis" || type === "end-ellipsis") {
            return (
              <Typography
                key={index}
                sx={{
                  px: 1,
                  fontSize: "14px",
                  fontFamily: "Inter",
                  color: "#666",
                }}
              >
                ...
              </Typography>
            );
          }

          if (type === "page") {
            return (
              <Box
                key={index}
                onClick={() => onPageChange(page)}
                sx={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  backgroundColor: selected ? "#FCE8F8" : "transparent",
                  display: "flex",
                  gap: 2,
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <Typography
                  sx={{
                    color: selected ? "#9D0385" : "#000",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontWeight: selected ? 600 : 400,
                  }}
                >
                  {page}
                </Typography>
              </Box>
            );
          }

          return null;
        })}
      </Box>

      <Typography
        onClick={() =>
          currentPage < totalPages && onPageChange(currentPage + 1)
        }
        sx={{
          ml: 2,
          color: currentPage === totalPages ? "#ccc" : "#000",
          cursor: currentPage === totalPages ? "not-allowed" : "pointer",
          fontFamily: "Inter",
          fontSize: "14px",
        }}
      >
        Next
      </Typography>
    </Grid>
  );
}
